import {corePublicApolloClient, throwGQLErrorMessage} from '../../utils/apollo-client';
import { emailValidation as mutation } from '../graphql/sign-up';

export default async function emailValidationApi(token, pin, tokenType) {
  const response = await corePublicApolloClient()
    .then((client) =>
      client.mutate({
        mutation,
        variables: { token, pin, tokenType }
      })
    )
    .catch(throwGQLErrorMessage);

  return response.data.emailValidation;
}
